var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M28.535 99.525v131.543h151.998v20.238H28.535c-11.177 0-20.266-9.077-20.266-20.238V99.525zm30.4-30.356v131.543h151.997v20.238H58.935c-11.177 0-20.267-9.077-20.267-20.238V69.17zM225.26 28.694 271.731 75.1v95.257c0 11.161-9.09 20.238-20.266 20.238H89.335c-11.178 0-20.267-9.077-20.267-20.238V48.932c0-11.151 9.09-20.238 20.266-20.238zm-14.328 20.238H89.334v121.424h162.141l-.01-80.95h-40.533zm10.133 80.95v20.237H109.601V129.88zm-40.532-40.476v20.238H109.6V89.406z"
})));
export default SvgBlock;